// extracted by mini-css-extract-plugin
export default {"tabs":"JoYmuFdWD3cHPRiB3mAN","tabsContent":"kX_zr4tDrc7AJgsPUuGU","tabsOptions":"VkgP_GmNy27Pak0V0Atk"};